import * as RAPIER from "./exports";
export * from "./exports";
export default RAPIER;
//# sourceMappingURL=rapier.js.map